/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { Grid, Typography, Divider } from "@material-ui/core";
import { useTranslation } from "react-i18next";

//custom libraries
import Paper from "../components/paper";
import { Button } from "../components";
import addressHelper from "../helpers/addressHelper";
import TextField from "@material-ui/core/TextField";

interface EditCustomerInformationProps {
  cusinfo: any;
  setShoweditForm: Function;
  setCusinfo: any;
  handleChange: any;
  clickSubmit: any;
  canSave: boolean;
  editFormData: any;
}

const EditCustomerInformation: React.FC<EditCustomerInformationProps> = (
  props: any
) => {
  const { t } = useTranslation();
  const {
    cusinfo,
    setShoweditForm,
    handleChange,
    clickSubmit,
    canSave,
    editFormData,
  } = props;
  return (
    <Paper>
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <Typography variant="h2">
            {t("Customer.CustomerDetailTitle")}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2">{t("Customer.LoginID")}</Typography>
          <Typography variant="body1">{editFormData?.logonId}</Typography>
        </Grid>
        <Grid item xs={6}>
          <TextField
            label={t("Customer.FirstName")}
            fullWidth
            defaultValue={editFormData?.firstName}
            id="firstName"
            name="firstName"
            onChange={(e: any) => {
              handleChange(e);
            }}
            inputProps={{
              maxLength: 128,
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label={t("Customer.LastName")}
            fullWidth
            defaultValue={editFormData?.lastName}
            id="lastName"
            name="lastName"
            required
            onChange={(e: any) => {
              handleChange(e);
            }}
            inputProps={{
              maxLength: 128,
            }}
          />
        </Grid>
        <Grid item>
          <Typography variant="h3">{t("Customer.ContactDetails")}</Typography>
        </Grid>
        <Grid item xs={6}>
          <TextField
            label={t("Customer.EmailAddress")}
            fullWidth
            defaultValue={editFormData?.email1}
            id="email1"
            name="email1"
            onChange={(e: any) => {
              handleChange(e);
            }}
            error={!addressHelper.validateEmail(editFormData?.email1)}
            helperText={
              !addressHelper.validateEmail(editFormData?.email1) &&
              t("CreateCustomer.EmailValidateMsg")
            }
            inputProps={{
              maxLength: 128,
              type: "email",
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label={t("Customer.PhoneNumber")}
            fullWidth
            defaultValue={editFormData?.phone1}
            id="phone1"
            name="phone1"
            onChange={(e: any) => {
              handleChange(e);
            }}
            error={!addressHelper.validatePhoneNumber(editFormData?.phone1)}
            helperText={
              !addressHelper.validatePhoneNumber(editFormData?.phone1) &&
              t("CreateCustomer.PhoneNumberValidateMsg")
            }
            inputProps={{
              maxLength: 20,
              type: "tel",
            }}
          />
        </Grid>
        <Grid item>
          <Typography variant="h3">{t("Customer.AddressDetails")}</Typography>
        </Grid>
        <Grid item xs={6}>
          <TextField
            label={t("Customer.StreetAddress")}
            fullWidth
            defaultValue={editFormData?.address1}
            id="address1"
            name="address1"
            required
            onChange={(e: any) => {
              handleChange(e);
            }}
            inputProps={{
              maxLength: 128,
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label={t("Customer.ZipCode")}
            fullWidth
            defaultValue={editFormData?.zipCode}
            id="zipCode"
            name="zipCode"
            required
            onChange={(e: any) => {
              handleChange(e);
            }}
            inputProps={{
              maxLength: 128,
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label={t("Customer.State")}
            fullWidth
            defaultValue={editFormData?.state}
            id="state"
            name="state"
            required
            onChange={(e: any) => {
              handleChange(e);
            }}
            inputProps={{
              maxLength: 128,
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label={t("Customer.Country")}
            fullWidth
            defaultValue={editFormData?.country}
            id="country"
            name="country"
            required
            onChange={(e: any) => {
              handleChange(e);
            }}
            inputProps={{
              maxLength: 128,
            }}
          />
        </Grid>
        <Grid
          item
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          spacing={4}>
          <Grid item>
            <Button
              color="secondary"
              size="small"
              onClick={(e: any) => {
                clickSubmit(e);
                setShoweditForm(false);
              }}
              disabled={!canSave}>
              {t("Customer.SaveChanges")}
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="text"
              size="small"
              onClick={(e: any) => {
                setShoweditForm(false);
              }}>
              {t("Customer.Cancel")}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default EditCustomerInformation;
